import { IJitsiMeetingProps } from "@jitsi/react-sdk/lib/types";
import { FC, useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { MEET_URL } from "../../../../constants/env";
import { useVideoMeeting } from "../../../../hooks/react-query/useVideoMeeting";
import { LoadingOverlay } from "@mantine/core";
import { useUser } from "../../../../hooks/react-query/useUser";

interface VideoMeetingProps {
  guestJWT: string;
  roomName: string;
}

const JitsiMeeting = dynamic(
  () =>
    import("@jitsi/react-sdk").then(({ JitsiMeeting }) => JitsiMeeting) as any,
  {
    ssr: false,
  }
) as FC<IJitsiMeetingProps>;

export function MeetingRoom() {
  const { user } = useUser();
  const router = useRouter();
  const [openMeeting, setOpenMeeting] = useState<boolean>(true);
  const { meeting, meetingIsLoading, setId } = useVideoMeeting();

  const [meetingRoom, setRoom] = useState<string>();

  useEffect(() => {
    const { id, room } = router.query;
    if (id) {
      setId(id.toString());
    }

    if (room) {
      setRoom(room.toString());
    }
  }, [router.query]);

  async function backToProfile() {
    await router.push(user ? "/user" : "/");
  }

  return (
    <div
      style={{ height: "calc(100vh - 50px)" }}
      className="flex flex-col justify-center"
    >
      <LoadingOverlay visible={meetingIsLoading} />
      {((meeting && !meetingIsLoading && openMeeting) || meetingRoom) && (
        <JitsiMeeting
          domain={MEET_URL}
          configOverwrite={{
            SHOW_BRAND_WATERMARK: false,
            SHOW_WATERMARK_FOR_GUESTS: false,
            SHOW_JITSI_WATERMARK: false,
            HIDE_DEEP_LINKING_LOGO: true,
          }}
          roomName={meeting ? meeting.room : meetingRoom ? meetingRoom : ""}
          spinner={() => <LoadingOverlay />}
          // onReadyToClose={backToProfile}
          getIFrameRef={(node) => (node.style.height = "60vh")}
        />
      )}
      {/*{!meeting && !meetingIsLoading && (*/}
      {/*  <div className="w-full flex justify-center">*/}
      {/*    <Alert*/}
      {/*      className="max-w-xl flex justify-center !px-8"*/}
      {/*      title="Alert title"*/}
      {/*      color={colors.danger}*/}
      {/*      icon={<IconAlertCircle />}*/}
      {/*    >*/}
      {/*      {i18n.t("videoMeeting.error")}*/}
      {/*    </Alert>*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  );
}
